import type { RouteComponentProps } from '@reach/router';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import * as ROUTES from '@constants/routes';

import AuthLayout, { BackLink, Subtitle } from '@layouts/AuthLayout';

const messages = defineMessages({
  resetSuccess: {
    id: 'forgotPassword.resetSuccess',
    defaultMessage:
      'Your password has been reset. You can now proceed to the login form and login.',
  },
  success: {
    id: 'forgotPassword.success',
    defaultMessage: 'Success!',
  },
  goBack: {
    id: 'forgotPassword.goBack',
    defaultMessage: 'Back to login',
  },
});

const SuccessForm: React.FC<RouteComponentProps> = () => {
  const { formatMessage } = useIntl();

  return (
    <AuthLayout title={formatMessage(messages.success)}>
      <Subtitle>{formatMessage(messages.resetSuccess)}</Subtitle>
      <BackLink to={ROUTES.LOGIN}>{formatMessage(messages.goBack)}</BackLink>
    </AuthLayout>
  );
};

export default SuccessForm;
